import { render, staticRenderFns } from "./BrandRetailerSearch.vue?vue&type=template&id=32da72e7&lang=pug"
import script from "./BrandRetailerSearch.vue?vue&type=script&lang=js"
export * from "./BrandRetailerSearch.vue?vue&type=script&lang=js"
import style0 from "./BrandRetailerSearch.vue?vue&type=style&index=0&id=32da72e7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports